import { CheckoutFlow } from '../flow/type'

/**
 * Maps a checkout flow name to its URL prefix
 *
 * This function converts a flow name (from FlowContext or pageProps) into the
 * corresponding URL prefix used by useAppRouter for automatic route prefixing.
 *
 * Flow prefix mapping:
 * - 'apple-paylater' → '/apple-paylater'
 * - 'default' → '' (no prefix, regular checkout)
 *
 * The prefix is used by useAppRouter methods (push, replace, etc.) to automatically
 * prepend the flow-specific path segment to all routes.
 *
 * @param flowName - The current checkout flow name from FlowContext
 * @returns The URL prefix for the flow (with leading slash, or empty string for no prefix)
 *
 * @example
 * ```typescript
 * const prefix = getFlowPrefix('apple-paylater')
 * // Returns: '/apple-paylater'
 *
 * const url = prefix + '/login'
 * // url = '/apple-paylater/login'
 * ```
 *
 * @example
 * ```typescript
 * const prefix = getFlowPrefix('default')
 * // Returns: ''
 *
 * const url = prefix + '/login'
 * // url = '/login'
 * ```
 */
export const getFlowPrefix = (flowName: CheckoutFlow): string => {
  switch (flowName) {
    case 'apple-paylater':
      return '/apple-paylater'
    default:
      return ''
  }
}
